import { useQuery } from '@tanstack/react-query';
import { shallow } from '@jwp/ott-common/src/utils/compare';
import ContentApiService from '@jwp/ott-common/src/services/ContentApiService';
import { getModule } from '@jwp/ott-common/src/modules/container';
import type { ApiError } from '@jwp/ott-common/src/utils/api';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import type { Playlist } from '@jwp/ott-common/types/playlist';
import { generatePlaylistPlaceholder } from '@jwp/ott-common/src/utils/collection';

const placeholderData = generatePlaylistPlaceholder(30);

export const useSearch = (searchTerm: string) => {
  const contentApiService = getModule(ContentApiService);
  const { config } = useConfigStore(({ config }) => ({ config }), shallow);

  return useQuery<Playlist, ApiError>({
    queryKey: ['search', searchTerm],
    queryFn: async () => contentApiService.search({ searchTerm, config }),
    placeholderData,
  });
};
